import {createReducer, on} from '@ngrx/store';
import {BelegKetteState, initialBelegKetteState} from '../states/beleg-kette.state';
import {BelegKetteActions} from '../actions/beleg-kette.actions';
import {FakturierungsbelegEntitiesActions} from '../actions/fakturierungsbeleg-entities.actions';


export const belegKetteReducer = createReducer(
  initialBelegKetteState,

  on(
    BelegKetteActions.loadBelegKetteSuccess,
    (state, {belegId, kette}): BelegKetteState => ({
      ...state,
      byBelegId: {
        ...state.byBelegId,
        [belegId]: kette,
      },
    }),
  ),

  /* INFO: Beim Fehlschlag den letzten Stand verwerfen — eine veraltete Kette ist irrefuehrender
   *       als keine. Ein geloeschter Beleg hat keine Kette mehr. */
  on(
    BelegKetteActions.loadBelegKetteFailure,
    FakturierungsbelegEntitiesActions.deleteFakturierungsbelegSuccess,
    (state, {belegId}): BelegKetteState => {
      const {[belegId]: _entfernt, ...rest} = state.byBelegId;
      return {
        ...state,
        byBelegId: rest,
      };
    },
  ),
);
